export { default } from './svg/input-checkmark.svg';
